import {Button, Stack} from '@mui/material';
import React from 'react';

import {ContentState} from 'presentation/components/ContentState';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {AppointmentsListErrorProps} from './types';
import {useAccountInformation} from 'presentation/pages';
import {useContractStatus} from 'presentation/hooks';

const {reload} = translations['pt-br'].commons;
const {newAppointment, myAppointmentsList} = translations['pt-br'].privateFlow.myAppointments;

export function AppointmentsListError({refresh, handleNewAppointment}: AppointmentsListErrorProps) {
	const {hideHealthHospitalComponent} = useAccountInformation();
	const {isContractSuspended} = useContractStatus();

	return (
		<ContentState
			description={
				hideHealthHospitalComponent ? '' : myAppointmentsList.listError.description
			}
			title={myAppointmentsList.listError.title}
			variant="error"
			footer={
				<Stack spacing={1}>
					<Button
						endIcon={<Icon name="reload" />}
						onClick={() => refresh()}
						variant="outlined"
						size="large">
						{reload}
					</Button>
					{hideHealthHospitalComponent || isContractSuspended ? null : (
						<Button
							endIcon={<Icon name="event-filled" />}
							onClick={handleNewAppointment}
							variant="contained"
							size="large">
							{newAppointment}
						</Button>
					)}
				</Stack>
			}
		/>
	);
}
